<template>
  <div>
    <!-- <div class="profile-photo-w mx-auto" v-if="userDetails.profilePhoto != ''">
      <img
        :src="$imageURL + '/' + userDetails.profilePhoto"
        alt="profile-pic"
        class="profile-photo-w md:p-2 lg:p-2 p-1 m-auto bg-white object-cover"
      />
      <div
        class="absolute top-4 right-4 cursor-pointer md:block lg:block hidden"
      >
        <input type="file" />
        <feather-icon icon="CameraIcon" />
      </div>
    </div> -->
    <div class="profile-photo-w mx-auto">
      <img
        src="@/views/e-learning/img/profile/blank-profile.png"
        alt="profile-pic"
        class="profile-photo-w md:p-2 lg:p-2 p-1 m-auto bg-white object-cover"
      />
    </div>
    <div class="mt-4">
      <h2 class="text-center font-bold text-xl">
        <!-- {{ userData.firstname + " " + userData.lastname }} -->
        Sumit Static
      </h2>
      <p class="text-sm text-center md:mt-2 lg:mt-2 mt-0 font-medium">
        <!-- {{ userDetails.designation }} -->
        UX Developer
      </p>
      <div
        class="flex justify-center md:mt-2 lg:mt-2 mt-0"
        v-if="userData.role == 'author'"
      >
        <p
          class="
            chips-sm
            w-20
            p-1
            rounded-full
            text-xs
            bg-warning-light
            text-center
            font-semibold
            text-warning
          "
        >
          {{ userData.role[0].toUpperCase() + userData.role.substring(1) }}
        </p>
        <!--  this is for teacher -->
      </div>
      <div
        class="flex justify-center md:mt-2 lg:mt-2 mt-0"
        v-else-if="userData.role == 'student'"
      >
        <p
          class="
            chips-sm
            w-20
            p-1
            rounded-full
            text-xs
            bg-light
            text-center
            font-semibold
            text-primary
          "
        >
          {{ userData.role[0].toUpperCase() + userData.role.substring(1) }}
        </p>
        <!-- this is for student -->
      </div>
    </div>

    <div class="md:mt-8 lg:mt-8 mt-6 px-4">
      <div v-if="userData.role == 'author'" class="flex justify-between">
        <div class="flex items-center">
          <feather-icon icon="BookIcon" svgClasses="w-4 " />
          <p class="text-sm font-medium ml-2">
            {{ userDetails.courses.length }} Courses
          </p>
        </div>

        <div class="flex items-center">
          <feather-icon icon="UserIcon" class="" svgClasses="w-4 " />
          <p class="text-sm font-medium ml-2">342 Students</p>
        </div>
      </div>
      <!-- this is for student -->
      <div v-else-if="userData.role == 'student'" class="mx-auto">
        <div class="flex items-center mt-8 px-4 justify-center">
          <feather-icon icon="BookIcon" class="" svgClasses="w-4 " />
          <p class="text-sm font-medium ml-2">3 Courses Enrolled</p>
        </div>
      </div>
    </div>

    <hr class="my-4" />
    <SocialMedia :userDetails="userDetails" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import SocialMedia from "./SocialMedia";
export default {
  props: {
    userDetails: Object,
  },
  data() {
    return {
      // key: value,
    };
  },
  computed: {
    ...mapState("auth", ["userData"]),
  },
  components: {
    SocialMedia,
  },
};
</script>
